// Toast.tsx
import { useToastStore } from '@/shared/lib/store';
import * as RdxToast from '@radix-ui/react-toast';
import React from 'react';
import * as Portal from '@radix-ui/react-portal';

export const Toast: React.FC = () => {
    // zustand로부터 상태 구독
    const { open, message, type, duration, hideToast } = useToastStore();

    return (
        <Portal.Root className="ttukttak">
            <RdxToast.Provider key={`${message}`} swipeDirection="right" duration={duration}>
                <RdxToast.Viewport className="toast-viewport">
                    <RdxToast.Root
                        open={open}
                        onOpenChange={(nextOpen) => {
                            // Radix가 Toast를 닫으면, Zustand로도 반영
                            if (!nextOpen) hideToast();
                        }}
                    >
                        <RdxToast.Title>
                            <div className="cont_layer" style={{ pointerEvents: 'none' }}>
                                <div className={`layer_box ${type}`}>
                                    <i></i>
                                    {message}
                                </div>
                            </div>
                        </RdxToast.Title>
                    </RdxToast.Root>
                </RdxToast.Viewport>
            </RdxToast.Provider>
        </Portal.Root>
    );
};
